import React from 'react'
import { Phone, Mail } from 'lucide-react';

export default function JsContact() {
    return (
        <>
            <span className='text-orange-400 text-sm'>
                <a href='tel: 416-568-9223' className='flex items-baseline mr-4'>
                    <Phone size={12} className='mr-1' />
                    {'416-568-9223'}
                </a>
            </span>
            <span className='text-orange-400 text-sm'>
                <a href='mailto: june@jsremodeling.ca' className='flex items-baseline mr-4'>
                    <Mail size={12} className='mr-1' />
                    {'june@jsremodeling.ca'}
                </a>
            </span>
        </>
    )
}
